module.exports = __webpack_public_path__ + "files/4030f9d0df934d7b611531e0f46c3585.png";